export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
  },
  mutations: {
    authRequest(state) {
      state.status = 'loading';
    },
    authSuccess(state, token, user) {
      state.status = 'success';
      state.token = token;
      state.user = user;
    },
    authError(state) {
      state.status = 'error';
    },
    authCancel(state) {
      state.status = '';
      state.token = '';
    },
  },
  actions: {
    async login(state) {
      // TODO
      state.commit('authRequest');
      // request
      // if success
      const token = 'abcdefg123456';
      const user = {
        name: 'placeholderName',
        config: {
          products: ['varilux-e-series', 'varilux-s-series', 'transition-signature'],
        },
      };
      localStorage.setItem('token', token);
      state.commit('authSuccess', token, user);
      // else
      // state.commit('autherror');
    },
    async logout(state) {
      state.commit('authCancel');
      localStorage.removeItem('token');
    },
  },
  getters: {
    isLoggedIn: state => {
      // TODO verify the token
      return !!state.token;
    },
    authStatus: state => state.status,
  },
};
